import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { PageTitle } from 'presentation/components/PageTitle';
import FormSimulateSale from './components/FormSimulateSale';

type props = {
    simualteUseCase: SimulateUseCaseInterface;
    propertyUseCase: PropertyUseCaseInterface;
};

const CU05101Page = ({ simualteUseCase, propertyUseCase }: props) => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-051-01-container"
        >
            <PageTitle title="キャッシュフローシミュレーション" />
            <div>
                ※ 当シミュレーションによって提供される結果は、あくまで参考情報であり、実際のキャッシュフローを保証するものではありません。
            </div>
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    overflowX: 'hidden',
                }}
            >
                <div>
                    <FormSimulateSale service={simualteUseCase} propertyUseCase={propertyUseCase} />
                </div>
            </section>
        </div>
    );
};

export default CU05101Page;
